import { EndgameSignupDialog } from '@colonist/clientforge';
import { LoginProviderEnum } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../analytics/Analytics.ts';
import { GuestPopupSource, sendGuestPopupContinueAsGuest, sendGuestPopupLoginClicked, sendGuestPopupShown } from '../../analytics/sendGuestPopupAnalytic.ts';
import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { StorageWrapper } from '../../StorageWrapper.ts';
import { navigateToPage } from '../../ui_utils/ClientUtils.ts';
import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
const renderEndgameSignupDialog = mountDialogUIReactComponent(EndgameSignupDialog);
const loginWithProvider = (url, provider)=>{
    CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.UserClickedLoginButton);
    sendGuestPopupLoginClicked(GuestPopupSource.MilestoneSignup, provider);
    StorageWrapper.clearUserState();
    navigateToPage(url);
};
export function showEndgameSignupDialog(playedGameCount) {
    sendGuestPopupShown(GuestPopupSource.MilestoneSignup);
    renderEndgameSignupDialog({
        playedGameCount: playedGameCount,
        onGoogleLogin: ()=>loginWithProvider(UIAPIEndpoints.googleAuth(), LoginProviderEnum.Google),
        onDiscordLogin: ()=>loginWithProvider(UIAPIEndpoints.discordAuth(), LoginProviderEnum.Discord),
        onAppleLogin: ()=>loginWithProvider(UIAPIEndpoints.appleAuth(), LoginProviderEnum.Apple),
        onContinueAsGuest: ()=>sendGuestPopupContinueAsGuest(GuestPopupSource.MilestoneSignup)
    });
}
